import { IGetOneResponse } from '../util/Types/Generic';
import { UploadImage } from '../util/Types/UploadImage';
import { ApiService } from './ApiService';

export class UploadService extends ApiService {
  static pathName = '/upload';

  static uploadFile(file: any, flowId?: string): Promise<IGetOneResponse<UploadImage>> {
    return this.post(`${this.pathName}/single`, file);
  }

  static extractText = (
    socketId: string,
    formData: FormData,
  ): Promise<IGetOneResponse<any>> => {
    return ApiService.post(
      `${this.pathName}/extract-text?socketId=${socketId}`, formData);
  };

  static extractTextByLink(url: any): Promise<IGetOneResponse<UploadImage>> {
    return this.post(`${this.pathName}/extract-text-link`, url);
  }
}
